"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var base_items_feed_query_class_1 = require("./base-items-feed-query.class");
var ItemsFeedQuery = /** @class */ (function (_super) {
    __extends(ItemsFeedQuery, _super);
    function ItemsFeedQuery(config, queryService) {
        var _this = _super.call(this, config, queryService) || this;
        _this.config = config;
        _this.queryService = queryService;
        return _this;
    }
    /**
     * Gets the runnable Observable
     */
    ItemsFeedQuery.prototype.toObservable = function () {
        return _super.prototype.runItemsFeedQuery.call(this);
    };
    /**
     * Gets 'Url' representation of query
     */
    ItemsFeedQuery.prototype.getUrl = function () {
        return _super.prototype.getItemFeedQueryUrl.call(this);
    };
    return ItemsFeedQuery;
}(base_items_feed_query_class_1.BaseItemsFeedQuery));
exports.ItemsFeedQuery = ItemsFeedQuery;
//# sourceMappingURL=items-feed-query.class.js.map